import store from '../../store'

export default async (to, from, next) => {
  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    try {
      await store.dispatch('auth/updateUserData')
    } catch (e) { }
  }

  next()
}



// WEBPACK FOOTER //
// ./src/router/middleware/checkAuth.js